{
  "version": 1,
  "asset_id": "e5db2f53-27a2-4054-8e8d-ff2d12a704b5",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e5db2f53-27a2-4054-8e8d-ff2d12a704b5/wordmark-240.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e5db2f53-27a2-4054-8e8d-ff2d12a704b5/wordmark-240.png",
  "original_filename": "wordmark-240.png",
  "size": 12036,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:59Z"
}
